import React from 'react'

import { Box } from '@chakra-ui/react'
import ReactPlayer from 'react-player'

import { PlayButtonIcon } from '@core/assets/icons/play_button'

import type { PostInfoV2 } from '@page/post-v2/types'

import './PostPageV2Video.scss'

const baseClass = 'PostPageV2Video'
const postPageClass = 'PostPageNew'

interface Props {
    postInfo?: PostInfoV2 | undefined | null
    isLoading?: boolean
}
function PostPageV2Video({ postInfo, isLoading }: Props) {
    if (isLoading || !postInfo?.data?.video?.url) {
        return null
    }

    return (
        <div className={baseClass}>
            <Box as={'div'} className={`${postPageClass}__video ${baseClass}__video`} overflow="hidden" pt={'20px'}>
                <Box
                    as="div"
                    // mt={8}
                    // filter={isPostExpired ? 'saturate(0)' : 'none'}
                    // pointerEvents={isPostExpired ? 'none' : 'auto'}
                    position="relative"
                    paddingTop={'56.25%'}
                    borderRadius="12px"
                    overflow="hidden"
                >
                    <ReactPlayer
                        url={postInfo?.data?.video?.url}
                        style={{ position: 'absolute', top: 0, left: 0 }}
                        width={'100%'}
                        height={'100%'}
                        playIcon={<PlayButtonIcon />}
                        controls={true}
                        config={{
                            vimeo: {
                                playerOptions: {
                                    responsive: true,
                                },
                            },
                        }}
                    />
                </Box>
            </Box>
        </div>
    )
}

export default PostPageV2Video
